import React from 'react';
import { observer } from "mobx-react";
import LinkWithIconV1 from 'ReactApp/Components/LinkWithIconV1/LinkWithIconV1';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartProductCardFavoriteV1Props = {
    card: DomainNs.ProductCardInterface,
    cardIndex: number,
    classes?: string[],
    attrs?: {},
    label?: string,
}

const CartProductCardFavoriteV1 = observer((props: CartProductCardFavoriteV1Props) => {

    const toogleHandler = (e: React.MouseEvent<HTMLElement>) => {
        showableCartInstance.favoriteCardByIndexSwitcher(props.cardIndex);
    }

    return (
        <LinkWithIconV1 onClick={toogleHandler} {...{
            label: props.label,
            classes: [
                'product-card-v6__action-favorite',
                'link-with-icon-v1_text-color-type-main',
                'link-with-icon-v1_decoration-type-none',
                ...(props.classes || [])
            ],
            attrs: props.attrs,
            iconProps: {
                svgSpriteId: (props.card.favoriteInfo.status === true) 
                    ? 'heart'
                    // TODO[needImpl]: replace normally filled grey icon 
                    // (while old black filled-icon)
                    : 'heart-icon-gray',
                width: 18,
                height: 18,
                classes: [
                    'link-with-icon-v1__icon'
                ]
            }
        }} />
    );

})

export default CartProductCardFavoriteV1;